import { generateTicket } from "private/generateToken";
import { NextPageContextEnhanced } from "../types/page";

export const ensureJwtTicketAndTimestamp = (
  context: NextPageContextEnhanced,
  isForce: Boolean = false,
): void => {
  let tgt_timestamp = context.getData("tgtTimestamp");
  let tgt_ticket = context.getData("tgtTicket");
  let deviceUUID = context.getData("deviceUUID");
  let sessionId = context.getData('sessionId');

  const logging = { old: {}, new: {}, memberData: {}, used: false };

  if (tgt_ticket && isForce) {
    logging.used = true;
    logging.old = {
      tgt_ticket,
      tgt_timestamp,
      deviceUUID,
      member_id: context.getData("member_id"),
      source: context.getData("source"),
    };
  }

    if (!deviceUUID) {
        deviceUUID = require("crypto").randomUUID();
        context.setData("deviceUUID", deviceUUID);
    }
    if (!sessionId) {
        const trackingId = context.getData("deviceUUID");
        let sessionIdPrefix =
            typeof trackingId == "string"
                ? trackingId.slice(0, trackingId.length * 0.5).replace("-", "")
                : trackingId + "-";
      sessionId = sessionId = sessionIdPrefix + require("crypto").randomUUID();
      context.setData("sessionId", sessionId);
      context.setData("sessionStartedAt", new Date().getTime());

    }


  if (isForce || !tgt_ticket || !tgt_timestamp) {
    [tgt_timestamp, tgt_ticket] = generateTicket(context);

    context.setData("tgtTimestamp", tgt_timestamp);

    context.setData("tgtTicket", tgt_ticket);

    context.setData("member_id", null);

    console.log("GenerateTicket new ticket", tgt_timestamp, tgt_ticket);
  }
  if (logging.used) {
    logging.new = {
      tgt_ticket: context.getData("tgtTicket"),
      tgt_timestamp: context.getData("tgtTimestamp"),
      deviceUUID: context.getData("deviceUUID"),
      member_id: context.getData("member_id"),
      source: context.getData("source"),
    };
    logging.memberData = context.memberData;
    context
      .techLogger("warning", "jwt-cookie-changed", logging)
      .then(console.info);
  }
};
